import React from "react";
import "./cve.css";
import Component from "./Component";
import cveData from "./data";
import DButton from "../../../Utilities/DButton";

const CVE = ({ limit = null, showMore = false }) => {
  const featuredData = cveData.filter((item) => item.showOnHome);
  const baseData = featuredData.length > 0 ? featuredData : cveData;
  const displayData =
    typeof limit === "number" ? baseData.slice(0, limit) : baseData;

  return (
    <section className="cve page-wrap">
      <div className="cmd">
        <span className="prompt">$</span> ls ~/research --featured
      </div>
      <div className="d-title">Research and CVEs</div>

      <div className="card-list">
        {displayData.map((item) => (
          <Component
            key={item.cve}
            cve={item.cve}
            cvss={item.cvss}
            details={item.details}
            link={item.link}
          />
        ))}
      </div>

      {showMore && cveData.length > displayData.length && (
        <div className="show-more fcs">
          <DButton text={`all ${cveData.length} CVEs →`} to="/cve" />
        </div>
      )}
    </section>
  );
};

export default CVE;
